import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { selectedResourcesByMasterIdSelector } from "../selectedResourcesByMasterIdSelector";
import { isResourceKubernetes } from "../../../../utils/helpers/isResourceKubernetes";

export const selectedResourcesAccountIdsSelector = createDraftSafeSelector(
  [selectedResourcesByMasterIdSelector],
  (data): string[] | undefined => {
    if (!data) {
      return;
    }

    return data
      .map((resource) => {
        if (!resource) {
          return "";
        }

        return isResourceKubernetes(resource)
          ? resource.cluster.id
          : resource.account.id;
      })
      .filter((id) => id);
  },
);
